import React from "react";
import { observer } from "mobx-react";
import Select from "react-select";
import { DateTimePicker } from "react-widgets";
import moment from "moment";
import momentLocalizer from "react-widgets-moment";
import { Label } from "react-bootstrap";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

@observer
export default class CubeQueryWizardFilterItem extends React.Component {
  handleSelectChange = (selectedOptions) => {
    let newArray = [];
    if (selectedOptions?.length > 0) {
      newArray = selectedOptions.map(option => option.value)
    }
    this.props.onUpdateFilterItemValues(newArray, this.props.itemID);
    this.props.onBlur(this.props.itemID);
  };

  handleTextInputChange = (event) => {
    const value = event.target.value;
    this.props.onUpdateFilterItemValues(
      value,
      this.props.itemID,
      this.props.getEqualityOption
    );
  };

  handleRangeChange = (event, type) => {
    const value = event.target.value;
    let from, to, numbers;
    if (type === "from") {
      from = value;
      to = this.props.values.to;
      numbers = null;
    } else if (type === "to") {
      from = this.props.values.from;
      to = value;
      numbers = null;
    } else {
      numbers = value;
      this.props.values.from = null;
      this.props.values.to = null;
    }
    this.props.onUpdateFilterItemValues(
      { from, to, numbers },
      this.props.itemID,
      this.props.getEqualityOption
    );
  };

  handleDateChange = (date, type) => {
    let from, to, singleDate;
    if (type === "from") {
      from = date;
      to = this.props.values.to;
      singleDate = null;
    } else if (type === "to") {
      from = this.props.values.from;
      to = date;
      singleDate = null;
    } else {
      singleDate = date;
      to = null;
      from = null;
    }
    this.props.onUpdateFilterItemValues(
      { singleDate, from, to },
      this.props.itemID,
      this.props.getEqualityOption
    );
  };

  handleFocus = () => {
    this.props.onFocus(this.props.itemID);
  };

  handleBlur = () => {
    this.props.onBlur(this.props.itemID);
  };

  handleEqualityOptionChange = (event) => {
    const value = event.target.value;
    this.props.onUpdateFilterItemValues(
      this.props.values,
      this.props.itemID,
      value
    );
  };

  render() {
    const {
      item,
      values,
      kind,
      allowedMembers,
      isPrimaryCube,
      hasForeignCubes,
      cubeName,
    } = this.props;

    const variable = item.items.find((x) => x.object.type === "Variable");
    const subdomain = item.items.find((x) => x.object.type === "Subdomain");
    const variableSet = item.items.find((x) => x.object.type === "VariableSet");

    // This will be rendered later
    let component = null;

    moment.locale("en");
    momentLocalizer();

    if (kind === "date-range") {
      // Date range
      const rangeComponent = (
        <div className="input-date-range input-text input-text-select">
          <select
            className="form-control form-control-select"
            value={this.props.getEqualityOption}
            onChange={this.handleEqualityOptionChange}
          >
            <option value="Range" selected="selected">
              Range
            </option>
            <option value="Equals">Equals</option>
          </select>
          From:
          <div className="date-picker date-picker-select">
            <DateTimePicker
              format={"DD.MM.YYYY"}
              defaultValue={values.from}
              time={false}
              onChange={(date) => this.handleDateChange(date, "from")}
            />
          </div>
          To:
          <div className="date-picker date-picker-select">
            <DateTimePicker
              format={"DD.MM.YYYY"}
              defaultValue={values.to}
              time={false}
              onChange={(date) => this.handleDateChange(date, "to")}
            />
          </div>
        </div>
      );
      switch (this.props.getEqualityOption) {
        case "Range":
          component = rangeComponent;
          break;
        case "Equals":
          const defaultValue = values.singleDate;
          component = (
            <div className="input-date-range input-text input-text-select">
              <select
                className="form-control form-control-select"
                value={this.props.getEqualityOption}
                onChange={this.handleEqualityOptionChange}
              >
                <option value="Range">Range</option>
                <option value="Equals">Equals</option>
              </select>
              Date:
              <div className="date-picker date-picker-select">
                <DateTimePicker
                  format={"DD.MM.YYYY"}
                  value={defaultValue}
                  time={false}
                  onChange={(date) => this.handleDateChange(date, "singleDate")}
                />
              </div>
            </div>
          );
          break;
        default:
          component = rangeComponent;
      }
    } else if (kind === "string") {
      // String
      component = (
        <div className="input-text input-text-select">
          <select
            className="form-control form-control-select"
            value={this.props.getEqualityOption}
            onChange={this.handleEqualityOptionChange}
          >
            <option value="Contains">Contains</option>
            <option value="Equals">Equals</option>
          </select>
          <input
            className="form-control"
            type="text"
            placeholder="Input text..."
            value={values}
            onChange={this.handleTextInputChange}
          />
        </div>
      );
    } else if (kind === "enumeratedSubdomain") {
      let enumeratedMembers = [];
      if (allowedMembers !== undefined) {
        enumeratedMembers = allowedMembers;
      } else if (
        subdomain &&
        subdomain.items !== undefined &&
        subdomain.items !== null &&
        subdomain.items.length
      ) {
        // Enumerated subdomain
        enumeratedMembers = subdomain.items
          .filter(
            (enumItem) =>
              enumItem.items &&
              enumItem.items[0] &&
              enumItem.items[0].object.type === "Member"
          )
          .map((enumItem) => enumItem.items)
          .map((x) => x[0].object);
      }
      const subdomainEnumerationOptions = enumeratedMembers.map((item) => ({
        label: `${item.name || "[No name]"} (${item.code})`,
        value: item.memberId,
      }));
      
      component = (
        <SelectEnumerated
          options={subdomainEnumerationOptions}
          values={this.props.values}
          onChange={this.handleSelectChange}
          onBlur={this.handleBlur}
          // onFocus={this.handleFocus}
          disabled={this.props.disabled}
          loading={this.props.loading}
        />
      );
    } else if (kind === "enumeratedVariableSet") {
      // Enumerated VariableSet
      const enumeratedVariableSet = variableSet.items
        .filter((enumItem) => {
          if (enumItem.items && enumItem.items.length) {
            const variable = enumItem.items.find(
              (subItem) => subItem.object.type === "Variable"
            );
            return variable !== undefined && variable !== null;
          }
          return false;
        })
        .map((enumItem) => enumItem.items)
        .map((enumItem) => {
          const variable = enumItem.find(
            (subItem) => subItem.object.type === "Variable"
          );
          return variable.object;
        })
        .sort((a, b) => a.code.localeCompare(b.code));

      const variableSetEnumerationOptions = enumeratedVariableSet.map(
        (item) => ({
          label: `${item.name || "[No name]"} (${item.code})`,
          value: item.variableId,
        })
      );
      component = (
        <SelectEnumerated
          options={variableSetEnumerationOptions}
          values={this.props.values}
          onChange={this.handleSelectChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          disabled={this.props.disabled}
          loading={this.props.loading}
        />
      );
    } else if (kind === "number-range") {
      // Number
      const defaultComponent = (
        <div className="input-number input-number-select">
          <select
            className="form-control form-control-select"
            value={this.props.getEqualityOption}
            onChange={this.handleEqualityOptionChange}
          >
            <option value="Range">Range</option>
            <option value="Equals">Equals</option>
          </select>
          <div className="input-number">
            From:
            <input
              className="form-control"
              type="number"
              placeholder="Input number..."
              onChange={(e) => this.handleRangeChange(e, "from")}
            />
            To:
            <input
              className="form-control"
              type="number"
              placeholder="Input number..."
              onChange={(e) => this.handleRangeChange(e, "to")}
            />
          </div>
        </div>
      );
      switch (this.props.getEqualityOption) {
        case "Range":
          component = defaultComponent;
          break;
        case "Equals":
          component = (
            <div className="input-number input-text-select">
              <select
                className="form-control form-control-select"
                value={this.props.getEqualityOption}
                onChange={this.handleEqualityOptionChange}
              >
                <option value="Range">Range</option>
                <option value="Equals">Equals</option>
              </select>
              <div className="input-number">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Input number..."
                  onChange={(e) => this.handleRangeChange(e, "numbers")}
                />
              </div>
            </div>
          );
          break;
        default:
          component = defaultComponent;
      }
    } else {
      return;
    }

    const labelTitleCube = isPrimaryCube
      ? `Primary cube: ${cubeName}\n`
      : `Foreign cube: ${cubeName}\n`;
    const labelTitle = `${hasForeignCubes ? labelTitleCube : ""}Variable: ${
      variable.object.name || "[No name]"
    } (${
      item.object.cubeVariableCode
    })\nRole: ${item.object.role.toUpperCase()}\nDesc: ${
      variable.object.description || "[No description]"
    }`;

    return (
      <React.Fragment>
        <div className="item-texts" title={labelTitle}>
          {hasForeignCubes && (
            <React.Fragment>
              <div className="item-text item-text-cube">{cubeName}</div>{" "}
              <div className="item-text-type">
                <span className="object-type label label-success">Cube</span>
                {" - "}
              </div>
            </React.Fragment>
          )}
          <div className="item-text item-text-variable">
            {`${variable.object.name || "[No name]"} (${
              item.object.cubeVariableCode
            }) `}
          </div>
          <div className="item-text-type">
            <span className="object-type label label-success">Variable</span>
          </div>{" "}
          {!item.object.isImplemented && !IS_BIRD_APP && (
            <div>
              <Label
                className={"object-implementation"}
                bsStyle="info"
              >
                LOGICAL
              </Label>
            </div>
            )}
        </div>
        {this.props.loading && this.props.kind === "enumeratedSubdomain" && (
          <div className="query-wizard-loader"></div>
        )}
        {component}
      </React.Fragment>
    );
  }
}

const SelectEnumerated = ({
  onChange,
  onBlur,
  onFocus,
  options,
  values,
  disabled,
}) => (
  <div className="select-enumerated">
    <Select
      closeMenuOnSelect={true}
      isDisabled={disabled}
      isMulti
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      options={options}
      isClearable={true}
      placeholder={disabled ? "Disabled while loading..." : "Choose values..."}
      value={options.filter(option => values.includes(option.value))}
    />
  </div>
);
